import { useQuery } from '@tanstack/react-query'
import { QUERIES } from '@/constants/queries'
import { getAllCoursesByCurriculum } from '@/services/education/get-all-courses-by-curriculum'
import type { DesiredEducationCourse } from '@/types/education/desired-education-course'
import { createTableConfig } from '@/utils/create-table-config'

function formatWorkload(workload: number) {
  return `${workload}h`
}

function createTable(data: DesiredEducationCourse[] | undefined) {
  const tableData = data?.map((item) => ({ data: item })) || []

  return createTableConfig<DesiredEducationCourse>(
    [
      { key: 'name', label: 'Nome da Disciplina', hidden: false },
      {
        key: 'workload',
        label: 'Carga Horária',
        hidden: false,
        width: '200px',
        toText: formatWorkload
      }
    ],
    tableData
  )
}

export const useCoursePreviewModal = (curriculum?: string) => {
  const { data: coursesData, isLoading: isCoursesLoading } = useQuery({
    queryKey: [QUERIES.QUERY_GET_COURSES_BY_CURRICULUM, curriculum],
    queryFn: () => getAllCoursesByCurriculum(curriculum),
    enabled: !!curriculum
  })

  return { states: { coursesData, isCoursesLoading }, actions: { createTable } }
}
